import { TransactionType } from "../../../views/Orders/enums";

const DEFAULT_GARAAZ_SUPPLIER_ID = "64ae87c051c0be36170dc718";

function isGaraazSupplier(
  supplierId: string,
  garaazSupplierIdFromConfig?: string,
): boolean {
  return (
    !!supplierId &&
    supplierId === (garaazSupplierIdFromConfig || DEFAULT_GARAAZ_SUPPLIER_ID)
  );
}

function isAllOrderItemsMarutiSuzuki(orderData: any): boolean {
  const items = orderData?.orderItems;
  if (!Array.isArray(items) || items.length === 0) return false;
  for (const item of items) {
    if (!item?.brand) return false;
    if (item.brand.trim().toLowerCase() !== "maruti suzuki") return false;
  }
  return true;
}

export function resolveDefaultEstimateSplitTransactionType(params: {
  supplierId?: string | null;
  orderData?: any;
  isSingleGaraazInvoiceRequired?: boolean;
  garaazSupplierIdFromConfig?: string;
}): TransactionType | "" {
  const { supplierId, orderData, isSingleGaraazInvoiceRequired, garaazSupplierIdFromConfig } =
    params;
  if (!supplierId) return "";
  if (
    isGaraazSupplier(supplierId, garaazSupplierIdFromConfig) ||
    isSingleGaraazInvoiceRequired
  ) {
    return TransactionType.TRADING;
  }
  if (isAllOrderItemsMarutiSuzuki(orderData)) {
    return TransactionType.FACILITATION;
  }
  return "";
}

export function getTradingDefaultsFromOrder(orderData: any): {
  discount: number;
  credit: number;
} {
  const discountFromOrder =
    orderData?.discount != null && orderData.discount !== ""
      ? Number(orderData.discount)
      : 0;
  const creditFromOrder =
    orderData?.creditNotePercentage != null &&
    orderData.creditNotePercentage !== ""
      ? Number(orderData.creditNotePercentage)
      : 0;
  return {
    discount: Number.isFinite(discountFromOrder) ? discountFromOrder : 0,
    credit: Number.isFinite(creditFromOrder) ? creditFromOrder : 0,
  };
}
